module.exports = __webpack_public_path__ + "static/media/kb.72e963b2.jpg";